import { focusFirstInvalidField } from '$core/helpers/focus-first-invaild-field';
import { handleFormHttpError } from '$core/helpers/server-errors-form-handler';
import { HttpErrorResponse } from '@angular/common/http';
import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
} from '@angular/core';
import { FormGroup, NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Directive()
export abstract class ModalBaseDirective implements AfterViewInit {
  public isLoading = false;
  public isViewInited = false;
  public selfCount = 0;

  constructor(
    protected modalRef: BsModalRef,
    protected modalService: BsModalService,
    protected translateService: TranslateService
  ) {}

  public ngAfterViewInit() {
    this.isViewInited = true;
    this.selfCount = this.modalService.getModalsCount();
  }

  @HostListener('window:popstate', ['$event'])
  public onPopState(event: Event) {
    this.hide();
  }

  public hide(type?: string | null) {
    if (type) {
      this.modalService.setDismissReason(type);
    } else {
      this.modalService.setDismissReason(null);
    }
    this.modalRef.hide();
  }

  public translate(key: string) {
    return this.translateService.instant(key);
  }

  protected handleError(
    res: HttpErrorResponse,
    form: NgForm | FormGroup,
    formEl: ElementRef<HTMLFormElement>
  ) {
    if (res.status === 422) {
      handleFormHttpError(res, form);
      focusFirstInvalidField(formEl);
    } else {
      throw res;
    }
  }
}
